module.exports = __webpack_public_path__ + "img/corumbatai.81ac7d6e.png";